/* HOLY case Shopify bridge. Only rendered for the configured product. */
(() => {
 'use strict';
 const configElement=document.getElementById('holy-case-config');
 if(!configElement)return;
 const cfg=JSON.parse(configElement.textContent);
 const params=new URLSearchParams(window.location.search);
 const root=(window.Shopify?.routes?.root||cfg.root||'/').replace(/\/?$/,'/');
 let frame=null,busy=false,pending=null;
 const storageKey='holy-case-checkout:'+cfg.productId;
 const copy={th:{failed:'ยังบันทึกแบบไม่สำเร็จ กรุณาลองอีกครั้ง',missing:'สินค้าเข้าตะกร้าแล้ว แต่ไฟล์แบบแนบไม่ครบ กรุณาติดต่อร้านก่อนชำระเงิน',conflict:'แบบนี้ถูกบันทึกไปแล้ว กรุณาเปิดตะกร้าหรือเริ่มแบบใหม่'},en:{failed:'Could not save your design. Please try again.',missing:'The item is in your cart but design attachments are incomplete. Please contact the store before paying.',conflict:'This design was already saved. Please open your cart or start a new design.'},zh:{failed:'保存失败，请重试。',missing:'商品已加入购物车，但设计附件不完整。付款前请联系商店。',conflict:'此设计已保存，请打开购物车或开始新设计。'}};
 window.HolyCase={openFromForm(form){const variant=Number(new FormData(form).get('id'));if(!cfg.variants.some(v=>v.id===variant&&v.available))throw Error('Variant unavailable');const quantityInput=document.querySelector('[name="quantity"][form="'+CSS.escape(form.id)+'"]')||form.querySelector('[name="quantity"]');const quantity=Number(quantityInput?.value||1);if(!Number.isSafeInteger(quantity)||quantity<1||quantity>100)throw Error('Invalid quantity');const url=new URL(cfg.productUrl,window.location.origin);url.search=window.location.search;url.searchParams.set('holy_designer','1');url.searchParams.set('variant',String(variant));url.searchParams.set('holy_quantity',String(quantity));try{sessionStorage.removeItem(storageKey)}catch{}window.location.assign(url.href)}};
 // Capture submit before theme/app handlers; do not rely on a Liquid boolean attribute.
 document.addEventListener('submit',event=>{
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||!form.querySelector('[data-holy-case-marker="15403882905845"]'))return;
  event.preventDefault();event.stopImmediatePropagation();
  if(form.querySelector('[name="id"]')?.disabled)return;
  try{window.HolyCase.openFromForm(form)}catch{window.alert('กรุณาตรวจสอบจำนวนและลองใหม่ / Please check the quantity and try again.')}
 },true);
 document.addEventListener('click',event=>{const link=event.target.closest?.('[data-holy-case-link]');if(!link)return;const form=link.closest('form');if(!form)return;event.preventDefault();try{window.HolyCase.openFromForm(form)}catch{window.location.assign(link.href)}},true);
 if(params.get('holy_designer')!=='1')return;
 const variantId=Number(params.get('variant')||cfg.defaultVariant),variant=cfg.variants.find(v=>v.id===variantId&&v.available);
 const quantity=Number(params.get('holy_quantity')||1);
 if(!variant||!Number.isSafeInteger(quantity)||quantity<1||quantity>100)return;
 function storageGet(){try{return JSON.parse(sessionStorage.getItem(storageKey))}catch{return null}}
 function storageSet(data){try{sessionStorage.setItem(storageKey,JSON.stringify(data))}catch{}}
 const existing=storageGet();if(existing?.id&&typeof existing.signature==='string')pending=existing;
 function error(message){frame.contentWindow.postMessage({type:'holy-case:error',message},window.location.origin)}
 function validDesign(d){return d&&d.version===1&&d.catalog==='holy-clay-90-v1'&&Array.isArray(d.colors)&&d.colors.length===5&&d.colors.every(c=>typeof c==='string'&&/^#[a-f0-9]{6}$/i.test(c))&&d.stage&&Number.isFinite(d.stage.width)&&d.stage.width>=100&&d.stage.width<=2000&&Number.isFinite(d.stage.height)&&d.stage.height>=100&&d.stage.height<=2000&&Array.isArray(d.items)&&d.items.length<=200&&d.items.every(v=>Number.isInteger(v.id)&&v.id>=0&&v.id<90&&[v.x,v.y,v.width,v.angle].every(Number.isFinite)&&v.x>=0&&v.x<=1&&v.y>=0&&v.y<=1&&v.width>0&&v.width<=1&&v.angle>=0&&v.angle<=360&&typeof v.name==='string'&&v.name.length<=80)}
 async function request(path, options = {}) {
  const response = await fetch(root + path, {
    credentials: 'same-origin',
    cache: 'no-store',
    ...options
  });

  const raw = await response.text();

  let data;

  try {
    data = JSON.parse(raw);
  } catch {
    console.error('[HOLY] Invalid response:', {
      path,
      status: response.status,
      body: raw.slice(0, 500)
    });

    throw new Error('Invalid Shopify response');
  }

  if (!response.ok || data.status >= 400) {
    console.error('[HOLY] Shopify error:', {
      path,
      status: response.status,
      description: data.description,
      message: data.message
    });

    const e = new Error(
      data.description ||
      data.message ||
      'Shopify rejected request'
    );

    e.shopifyRejected = true;
    e.httpStatus=response.status; e.details=typeof data.description==='string'?data.description:typeof data.message==='string'?data.message:'';
    throw e;
  }

  return data;
}
 async function findSaved(id){const cart=await request('cart.js');return cart.items.find(item=>item.properties?._Holy_design_id===id)}
 function complete(item){const p=item?.properties;return p&&typeof p['Design preview']==='string'&&p['Design preview'].includes('/uploads/')&&typeof p['Production layout']==='string'&&p['Production layout'].includes('/uploads/')}
 window.addEventListener('message',async event=>{
  if(event.source!==frame?.contentWindow||event.origin!==window.location.origin)return;
  const message=event.data;
  if(message?.type==='holy-case:back'){if(busy)return;const url=new URL(window.location.href);['holy_designer','holy_quantity'].forEach(k=>url.searchParams.delete(k));window.location.assign(url.href);return}
  if(message?.type!=='holy-case:checkout'||busy)return;
  const lang=copy[message.language]?message.language:'th';
  console.log('[HOLY MOBILE DEBUG]', {
  stageWidth: message.design?.stage?.width,
  stageHeight: message.design?.stage?.height,
  validDesign: validDesign(message.design),
  previewType: message.preview?.type,
  previewSize: message.preview?.size,
  isBlob: message.preview instanceof Blob
});
  if(!validDesign(message.design)){error(copy[lang].failed+' [DESIGN]');return}
  let preview=message.preview;
  // A data URL avoids Safari Blob structured-clone differences between iframe and parent.
  if(typeof message.previewData==='string'&&message.previewData.startsWith('data:image/png;base64,')&&message.previewData.length<=12*1024*1024){
   try{const binary=atob(message.previewData.slice(22));const bytes=Uint8Array.from(binary,c=>c.charCodeAt(0));preview=new Blob([bytes],{type:'image/png'})}catch{error(copy[lang].failed+' [IMAGE-DECODE]');return}
  }
  if(Object.prototype.toString.call(preview)!=='[object Blob]'||preview.type!=='image/png'||preview.size<100||preview.size>8*1024*1024){error(copy[lang].failed+' [IMAGE]');return}
  busy=true;
  try{
   const signature=JSON.stringify({variantId,quantity,design:message.design});
   // A stable token allows reconciliation after a lost network response, without adding twice.
   if(pending&&pending.signature!==signature){const prior=await findSaved(pending.id);if(prior||pending.sent){error(copy[lang].conflict);return}pending=null}
   if(!pending){pending={id:crypto.randomUUID(),signature};storageSet(pending)}
   let item=await findSaved(pending.id);
   if(!item){
    if(pending.sent){error(copy[lang].failed+' [PENDING]');return}
    const form=new FormData();form.append('id',String(variantId));form.append('quantity',String(quantity));
    form.append('properties[_Holy_design_id]',pending.id);form.append('properties[_Holy_catalog]','holy-clay-90-v1');
    ['1 · Lid','2 · Top','3 · Middle','4 · Bottom','5 · Base'].forEach((key,i)=>form.append('properties['+key+']',message.design.colors[i]));
    form.append('properties[Charms]',String(message.design.items.length));
    form.append('properties[Design preview]',preview,'holy-case-'+pending.id+'.png');
    const production={...message.design,designId:pending.id,variantId,quantity};
    form.append('properties[Production layout]',new Blob([JSON.stringify(production,null,2)],{type:'text/plain'}),'holy-case-'+pending.id+'.txt');
    pending.sent=true;storageSet(pending);
    try{await request('cart/add.js',{method:'POST',body:form})}catch(e){if(e.shopifyRejected){pending.sent=false;storageSet(pending);throw e};/* Reconcile ambiguous network failures with the cart below. */}
    item=await findSaved(pending.id);
   }
   if(!item)throw Error('Cart item not found');
   if(item.variant_id!==variantId||item.quantity!==quantity)throw Error('Cart mismatch');
   if(!complete(item)){error(copy[lang].missing);return}
   // Keep the token until checkout navigation, so refresh/back cannot add another copy accidentally.
   const checkout=new URL(root+'checkout',window.location.origin);window.location.assign(checkout.href);
  }catch(e){
  console.error('[HOLY CHECKOUT ERROR]', e);

  error(copy[lang].failed+' ['+(e.shopifyRejected?'SHOPIFY-'+e.httpStatus:'NETWORK')+']'+(e.details?' '+e.details:''));
}finally{
  busy=false;
}
 });
 const shell=document.createElement('section');shell.id='holy-case-screen';shell.setAttribute('aria-label','HOLY DECORATE CASE');shell.style.cssText='position:fixed;inset:0;z-index:2147483000;background:#fff6fa;';
 frame=document.createElement('iframe');frame.title='HOLY DECORATE CASE designer';frame.style.cssText='width:100%;height:100%;border:0;display:block;';
 let initialDesign=null;try{const saved=JSON.parse(pending?.signature||'null');if(saved?.variantId===variantId&&saved.quantity===quantity&&validDesign(saved.design))initialDesign=saved.design}catch{}
 const host={quantity,price:variant.price,currency:cfg.currency,origin:window.location.origin,initialDesign};
 const boot='<script>window.HolyHost='+JSON.stringify(host).replace(/</g,'\\u003c')+';<\/script>';
 frame.srcdoc=window.HolyCaseDocument.replace('<!--HOLY_HOST_BOOT-->',boot).replaceAll('__HOLY_SHEET_1__',cfg.sheet1).replaceAll('__HOLY_SHEET_2__',cfg.sheet2);
 shell.append(frame);document.body.append(shell);document.body.style.overflow='hidden';
})();
